// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Yz7a","consentsList":"PatientConsents_consentsList__3onw4","consentsListEmpty":"PatientConsents_consentsListEmpty__2dHFp"};